import { SiteMeta } from '@/components/site/SiteMeta';
import { StaticBody } from '@/pages/site/StaticBody';
import { SetoresBody } from '@/pages/site/content/SetoresBody';

export function SetoresPage() {
  return (
    <>
      <SiteMeta
        title={'Setores - Operax'}
        description={'Clínicas, imobiliárias, autopeças, serviços, beleza, educação e varejo: a mesma base no vocabulário do seu setor.'}
        path={'/setores'}
      />
      <StaticBody html={SetoresBody} />
    </>
  );
}
